// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BorderOutlined,
  BoxPlotOutlined,
  ChromeOutlined,
  DeploymentUnitOutlined,
  GatewayOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  SmileOutlined,
  StopOutlined
} from '@ant-design/icons';
import Box from '@mui/material/Box';
// icons
const icons = {
  ChromeOutlined,
  MenuUnfoldOutlined,
  BoxPlotOutlined,
  StopOutlined,
  BorderOutlined,
  SmileOutlined,
  GatewayOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  BarChartOutlinedIcon
};
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import TopicOutlinedIcon from '@mui/icons-material/TopicOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DataThresholdingOutlinedIcon from '@mui/icons-material/DataThresholdingOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other = {
  id: 'other',
  type: 'group',
  children: [
    {
      id: 'home_dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/app',
      icon: icons.ChromeOutlined
    },
    {
      id: 'upload_document',
      title: 'Upload Document',
      type: 'item',
      url: '/app/upload-document',
      icon: icons.BoxPlotOutlined
    },
    {
      id: 'data_tables',
      title: 'Entities Table',
      type: 'item',
      url: '/app/data-tables',
      icon: icons.DeploymentUnitOutlined
    },
    {
      id: 'tables',
      title: <FormattedMessage id="ACSAF Tables" />,
      type: 'collapse',
      icon: icons.BoxPlotOutlined,
      children: [
        {
          id: 'balance-1',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <AccountBalanceOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="BALANCE" />
            </Box>
          ),
          type: 'collapse',
          children: [
            {
              id: 'sub-menu-level-2.1',
              title: (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TopicOutlinedIcon fontSize="extra-small" />
                  <FormattedMessage id="Balance Sheet" />
                </Box>
              ),
              caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
              type: 'item',
              url: '/app/balance-sheet'
            }
          ]
        },
        {
          id: 'sub-menu-level-1.2',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <FolderCopyOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="PORTFOLIO" />
            </Box>
          ),
          type: 'collapse',
          children: [
            {
              id: 'sub-menu-level-2.1',
              title: (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <BarChartOutlinedIcon fontSize="extra-small" />
                  <FormattedMessage id="Performance Rac" />
                </Box>
              ),
              caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
              type: 'item',
              url: '/app/performance-rac'
            },
            {
              id: 'sub-menu-level-2.1',
              title: (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <AddchartOutlinedIcon fontSize="extra-small" />
                  <FormattedMessage id="Statement  Nav" />
                </Box>
              ),
              caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
              type: 'item',
              url: '/app/statement-nav'
            }
          ]
        }
      ]
    },
    {
      id: 'tables',
      title: <FormattedMessage id="Reports" />,
      type: 'collapse',
      icon: icons.BarChartOutlinedIcon,
      children: [
        {
          id: 'sub-menu-level-2.1',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <AssessmentOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="Portfolio Performance" />
            </Box>
          ),
          caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
          type: 'item',
          url: '/app/report/gross_portfolio_performance'
        },
        {
          id: 'sub-menu-level-2.2',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <DataThresholdingOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="Entity Performance" />
            </Box>
          ),
          caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
          type: 'item',
          url: '/app/report/gross_category_performance'
        },
        {
          id: 'sub-menu-level-2.3',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <AccountTreeOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="Historical Allocation ($)" />
            </Box>
          ),
          caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
          type: 'item',
          url: '/app/report/gross_historical_allocations'
        },
        {
          id: 'sub-menu-level-2.4',
          title: (
            <Box display="flex" alignItems="center" gap={0.5}>
              <AccountTreeOutlinedIcon fontSize="extra-small" />
              <FormattedMessage id="Historical Allocation (%)" />
            </Box>
          ),
          caption: <FormattedMessage id="menu-level-subtitle-sub-item" />,
          type: 'item',
          url: '/app/report/gross_historical_alloc_percentage'
        }
      ]
    }
  ]
};

export default other;
